// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__cfuqH","container":"styles_container__UgO4O","container__form":"styles_container__form__fu1yk","container__buttons":"styles_container__buttons__rprLz"};